import React from 'react';
import { TeamStats } from './types';
import { FilteredMatchesList } from './matches/FilteredMatchesList';
import { StatsTable } from './match-results/StatsTable';
import { getFilteredMatches } from './match-results/utils';

interface MatchResultsSectionProps {
  teamStats: TeamStats;
  teamName: string;
  matches: any[];
}

export const MatchResultsSection: React.FC<MatchResultsSectionProps> = ({ 
  teamStats,
  teamName,
  matches
}) => {
  const [selectedStat, setSelectedStat] = React.useState<string | null>(null);
  const [selectedLocation, setSelectedLocation] = React.useState<'overall' | 'home' | 'away' | null>(null);

  const handleStatClick = (stat: string, location: 'overall' | 'home' | 'away' = 'overall') => {
    if (selectedStat === stat && selectedLocation === location) {
      setSelectedStat(null);
      setSelectedLocation(null);
    } else {
      setSelectedStat(stat);
      setSelectedLocation(location);
    }
  };

  const filteredMatches = getFilteredMatches(matches, selectedStat, selectedLocation, teamName);

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Match Results</h2>
      <StatsTable
        teamStats={teamStats}
        selectedStat={selectedStat}
        selectedLocation={selectedLocation}
        onStatSelect={handleStatClick}
      />

      {filteredMatches.length > 0 && (
        <FilteredMatchesList 
          matches={filteredMatches}
          selectedStat={selectedStat}
        />
      )}
    </div>
  );
};